/*create-an-empty-directory*/
/*add-a-packagejson*/
/*add-a-tsconfigjson*/
/*add-a-src-directory-with-source-code*/
/*add-the-package-to-an-application*/
/*edit-turbojson*/
/*run-turbo-build*/
/*best-practices-for-internal-packages*/
/*one-purpose-per-package*/
/*application-packages-do-not-contain-shared-code*/
/*next-steps*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "创建内部包",
  "description": "了解如何为你的 monorepo 创建内部包。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "内部软件包 是你工作区的基石，为你提供了一种在代码库中共享代码和功能的强大方法。Turborepo 会使用 package.json 中的依赖自动理解内部包之间的关系，并在后台创建 软件包图表 以优化代码库的工作流程。"
  }, {
    "heading": "",
    "content": "¥Internal Packages are the building blocks of your workspace, giving you a powerful way to share code and functionality across your repo. Turborepo automatically understands the relationships between Internal Packages using the dependencies in package.json, creating a Package Graph under the hood to optimize your repository's workflows."
  }, {
    "heading": "",
    "content": "让我们使用 软件包结构 部分中的指导和 已编译的软件包 模式，创建你的第一个内部包，以便在你的代码库中共享数学实用程序。在以下步骤中，我们假设你已经拥有 使用以下方式创建新仓库 create-turbo 或正在使用类似结构的代码库。"
  }, {
    "heading": "",
    "content": "¥Let's create your first Internal Package to share math utilities in your repo using the guidance in the Anatomy of a package section and the Compiled Packages pattern. In the steps below, we assume you've created a new repository using create-turbo or are using a similarly structured repository."
  }, {
    "heading": "创建一个空目录-create-an-empty-directory",
    "content": "¥Create an empty directory"
  }, {
    "heading": "创建一个空目录-create-an-empty-directory",
    "content": "你需要一个用于放置包的目录。让我们在 ./packages/math 上创建一个。"
  }, {
    "heading": "创建一个空目录-create-an-empty-directory",
    "content": "¥You'll need a directory to put the package in. Let's create one at ./packages/math."
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "¥Add a package.json"
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "接下来，为包创建 package.json。添加此文件后，你将满足 内部包的两个要求 的要求，使其可被 Turborepo 和你的工作区其他部分发现。"
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "¥Next, create the package.json for the package. By adding this file, you'll fulfill the two requirements for an Internal Package, making it discoverable to Turborepo and the rest of your Workspace."
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "package.json 中的 name 字段决定了你的包如何在你的工作区中导入。你在此处选择的名称（例如 @repo/math）将与其他包导入它的方式完全一致（例如 import {add} from '@repo/math/add'）。"
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "¥The name field in your package.json determines how your package can be\nimported throughout your workspace. The name you choose here (e.g.\n@repo/math) is exactly how other packages will import it (e.g. import {add}\n        from '@repo/math/add')."
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "让我们逐一分解这个 package.json："
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "¥Let's break down this package.json piece-by-piece:"
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "name：这是包发现的最关键字段。值 @repo/math 将成为工作区中所有导入语句使用的确切标识符。如果更改此名称，则必须相应地更新所有导入语句。"
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "¥name: This is the most critical field for package discoverability. The value @repo/math becomes the exact identifier used in import statements throughout your workspace. If you change this name, you must update all import statements accordingly."
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "scripts：dev 和 build 脚本使用 TypeScript 编译器 编译软件包。dev 脚本将监视源代码的更改并自动重新编译软件包。"
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "¥scripts: The dev and build script compile the package using the TypeScript compiler. The dev script will watch for changes to source code and automatically recompile the package."
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "devDependencies：typescript 和 @repo/typescript-config 都是 devDependencies，因此你可以在 @repo/math 包中使用这些包。在实际软件包中，你可能会有更多 devDependencies 和 dependencies。 - 但我们现在可以保持简单。"
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "¥devDependencies: typescript and @repo/typescript-config are devDependencies so you can use those packages in the @repo/math package. In a real-world package, you will likely have more devDependencies and dependencies - but we can keep it simple for now."
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "exports：为包定义多个入口点，以便可以在其他包（import { add } from '@repo/math/add'）中使用。"
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "¥exports: Defines multiple entrypoints for the package so it can be used in other packages (import { add } from '@repo/math/add')."
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "需要注意的是，此 package.json 将内部包 @repo/typescript-config 声明为依赖。Turborepo 会将 @repo/math 识别为 @repo/typescript-config 的依赖，以便对任务进行排序。"
  }, {
    "heading": "添加-packagejson-文件-add-a-packagejson",
    "content": "¥Notably, this package.json declares an Internal Package, @repo/typescript-config, as a dependency. Turborepo will recognize @repo/math as a dependent of @repo/typescript-config for ordering your tasks."
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "¥Add a tsconfig.json"
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "通过将 tsconfig.json 文件添加到包的根目录来指定此包的 TypeScript 配置。TypeScript 具有 extends 键，允许你在整个代码库中使用基本配置，并根据需要使用不同的选项进行覆盖。"
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "¥Specify the TypeScript configuration for this package by adding a tsconfig.json file to the root of the package. TypeScript has an extends key, allowing you to use a base configuration throughout your repository and overwrite with different options as needed."
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "你在这里完成了四件重要的事情："
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "¥You've done four important things here:"
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "./packages/typescript-config 中的 @repo/typescript-config/base.json 配置包含你需要的所有配置，因此你可以从中扩展。"
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "¥The @repo/typescript-config/base.json configuration that lives in ./packages/typescript-config has all the configuration you need so you extend from it."
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "compilerOptions 中的 outDir 键 会告诉 TypeScript 将编译输出放在哪里。它与 package.json 中 exports 指定的目录匹配。"
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "¥The outDir key in compilerOptions tells TypeScript where to put the compiled output. It matches the directory specified in your exports in package.json."
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "compilerOptions 中的 rootDir 键 确保 outDir 中的输出使用与 src 目录相同的结构。"
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "¥The rootDir key in compilerOptions ensures that the output in outDir uses the same structure as the src directory."
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "include 和 exclude 键并非从基本配置 根据 TypeScript 规范 继承，因此你在此处添加了它们。"
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "¥The include and exclude keys are not inherited from the base configuration, according to the TypeScript specification, so you've included them here."
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "关于 TypeScript 配置还有很多需要学习，但目前这是一个很好的起点。如果你想了解更多信息，请访问 TypeScript 官方文档 或 我们的 TypeScript 指南。"
  }, {
    "heading": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "¥There's a lot more to learn about TypeScript configuration, but this is a good\nplace to start for now. If you'd like to learn more, visit the official\nTypeScript documentation or our\nTypeScript guide."
  }, {
    "heading": "添加包含源代码的-src-目录-add-a-src-directory-with-source-code",
    "content": "¥Add a src directory with source code"
  }, {
    "heading": "添加包含源代码的-src-目录-add-a-src-directory-with-source-code",
    "content": "你现在可以为你的包编写一些代码。在 src 目录中创建两个文件："
  }, {
    "heading": "添加包含源代码的-src-目录-add-a-src-directory-with-source-code",
    "content": "¥You can now write some code for your package. Create two files inside a src directory:"
  }, {
    "heading": "添加包含源代码的-src-目录-add-a-src-directory-with-source-code",
    "content": "这些文件映射到你稍后运行 turbo build 时 tsc 将创建的输出。"
  }, {
    "heading": "添加包含源代码的-src-目录-add-a-src-directory-with-source-code",
    "content": "¥These files map to the outputs that will be created by tsc when you run turbo build in a moment."
  }, {
    "heading": "将包添加到应用-add-the-package-to-an-application",
    "content": "¥Add the package to an application"
  }, {
    "heading": "将包添加到应用-add-the-package-to-an-application",
    "content": "你已准备好在应用中使用新的包。让我们将它添加到 web 应用中。"
  }, {
    "heading": "将包添加到应用-add-the-package-to-an-application",
    "content": "¥You're ready to use your new package in an application. Let's add it to the web application."
  }, {
    "heading": "将包添加到应用-add-the-package-to-an-application",
    "content": "你只需更改代码库中的依赖即可。确保运行包管理器的安装命令来更新锁文件。"
  }, {
    "heading": "将包添加到应用-add-the-package-to-an-application",
    "content": "¥You just changed the dependencies in your repo. Make sure to run your package\nmanager's installation command to update your lockfile."
  }, {
    "heading": "将包添加到应用-add-the-package-to-an-application",
    "content": "@repo/math 现在可在 web 应用中使用，你可以在代码中使用它："
  }, {
    "heading": "将包添加到应用-add-the-package-to-an-application",
    "content": "¥@repo/math is now available in the web application, you can use it in your code:"
  }, {
    "heading": "edit-turbojson-edit-turbojson",
    "content": "将新 @repo/math 库的工件添加到 turbo.json 中 build 任务的 outputs 中。这确保了 Turborepo 会缓存其构建输出，因此当你开始运行构建时，它们可以立即恢复。"
  }, {
    "heading": "edit-turbojson-edit-turbojson",
    "content": "¥Add the artifacts for the new @repo/math library to the outputs for the build task in turbo.json. This ensures that its build outputs will be cached by Turborepo, so they can be restored instantly when you start running builds."
  }, {
    "heading": "运行-turbo-build-run-turbo-build",
    "content": "¥Run turbo build"
  }, {
    "heading": "运行-turbo-build-run-turbo-build",
    "content": "如果你已经安装了 全局安装 turbo，请在工作区根目录的终端中运行 turbo build。你还可以使用包管理器从 package.json 运行 build 脚本，这将使用 turbo run build。"
  }, {
    "heading": "运行-turbo-build-run-turbo-build",
    "content": "¥If you've installed turbo globally, run turbo build in your terminal at the root of your Workspace. You can also run the build script from package.json with your package manager, which will use turbo run build."
  }, {
    "heading": "运行-turbo-build-run-turbo-build",
    "content": "@repo/math 包在 web 应用之前构建，以便 ./packages/math/dist 中的运行时代码在 web 应用打包时可供使用。"
  }, {
    "heading": "运行-turbo-build-run-turbo-build",
    "content": "¥The @repo/math package built before the web application built so that the runtime code in ./packages/math/dist is available to the web application when it bundles."
  }, {
    "heading": "运行-turbo-build-run-turbo-build",
    "content": "你可以再次运行 turbo build，以毫秒为单位查看你的 web 应用的重建情况。我们将在 缓存指南 中详细讨论这一点。"
  }, {
    "heading": "运行-turbo-build-run-turbo-build",
    "content": "¥You can run turbo build again to see your web application rebuild in\nmilliseconds. We'll discuss this at length in the Caching\nguide."
  }, {
    "heading": "内部软件包的最佳实践-best-practices-for-internal-packages",
    "content": "¥Best practices for Internal Packages"
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "¥One \"purpose\" per package"
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "创建内部包时，建议创建包含单个 \"purpose\" 的包。这并非严格的科学或规则，而是一项最佳实践，取决于你的仓库、规模、组织、团队需求等等。此策略有几个优点："
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "¥When you're creating Internal Packages, it's recommended to create packages that have a single \"purpose\". This isn't a strict science or rule, but a best practice depending on your repository, your scale, your organization, what your teams need, and more. This strategy has several advantages:"
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "更易于理解：随着仓库规模的扩大，在仓库中工作的开发者将更容易找到他们需要的代码。"
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "¥Easier to understand: As a repository scales, developers working in the repository will more easily be able to find the code they need."
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "减少每个包的依赖：每个包使用更少的依赖，使 Turborepo 能够更有效地使用 修剪软件包图的依赖。"
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "¥Reducing dependencies per package: Using fewer dependencies per package makes it so Turborepo can more effectively prune the dependencies of your package graph."
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "一些示例如下："
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "¥Some examples include:"
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "@repo/ui：包含所有共享 UI 组件的包"
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "¥@repo/ui: A package containing all of your shared UI components"
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "@repo/tool-specific-config：用于管理特定工具配置的包"
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "¥@repo/tool-specific-config: A package for managing configuration of a specific tool"
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "@repo/graphs：用于创建和操作图形数据的字段特定库"
  }, {
    "heading": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "¥@repo/graphs: A domain-specific library for creating and manipulating graphical data"
  }, {
    "heading": "应用包不包含共享代码-application-packages-do-not-contain-shared-code",
    "content": "¥Application Packages do not contain shared code"
  }, {
    "heading": "应用包不包含共享代码-application-packages-do-not-contain-shared-code",
    "content": "创建 应用包 时，最好避免在这些包中放置共享代码。相反，你应该为共享代码创建一个单独的包，并让应用包依赖于该包。"
  }, {
    "heading": "应用包不包含共享代码-application-packages-do-not-contain-shared-code",
    "content": "¥When you're creating Application Packages, it's best to avoid putting shared code in those packages. Instead, you should create a separate package for the shared code and have the application packages depend on that package."
  }, {
    "heading": "应用包不包含共享代码-application-packages-do-not-contain-shared-code",
    "content": "此外，应用包不应安装到其他包中。相反，它们应该被视为 软件包图表 的入口点。"
  }, {
    "heading": "应用包不包含共享代码-application-packages-do-not-contain-shared-code",
    "content": "¥Additionally, Application Packages are not meant to be installed into other packages. Instead, they should be thought of as an entrypoint to your Package Graph."
  }, {
    "heading": "应用包不包含共享代码-application-packages-do-not-contain-shared-code",
    "content": "此规则包含 罕见例外。"
  }, {
    "heading": "应用包不包含共享代码-application-packages-do-not-contain-shared-code",
    "content": "¥There are rare\nexceptions\nto this rule."
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Next steps"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "新的内部软件包到位后，你可以启动 配置任务。"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥With a new Internal Package in place, you can start configuring tasks."
  }],
  "headings": [{
    "id": "创建一个空目录-create-an-empty-directory",
    "content": "创建一个空目录 /*create-an-empty-directory*/"
  }, {
    "id": "添加-packagejson-文件-add-a-packagejson",
    "content": "添加 package.json 文件 /*add-a-packagejson*/"
  }, {
    "id": "添加-tsconfigjson-add-a-tsconfigjson",
    "content": "添加 tsconfig.json /*add-a-tsconfigjson*/"
  }, {
    "id": "添加包含源代码的-src-目录-add-a-src-directory-with-source-code",
    "content": "添加包含源代码的 src 目录 /*add-a-src-directory-with-source-code*/"
  }, {
    "id": "将包添加到应用-add-the-package-to-an-application",
    "content": "将包添加到应用 /*add-the-package-to-an-application*/"
  }, {
    "id": "edit-turbojson-edit-turbojson",
    "content": "Edit turbo.json /*edit-turbojson*/"
  }, {
    "id": "运行-turbo-build-run-turbo-build",
    "content": "运行 turbo build /*run-turbo-build*/"
  }, {
    "id": "内部软件包的最佳实践-best-practices-for-internal-packages",
    "content": "内部软件包的最佳实践 /*best-practices-for-internal-packages*/"
  }, {
    "id": "每个包一个-purpose-文件-one-purpose-per-package",
    "content": "每个包一个 \"purpose\" 文件 /*one-purpose-per-package*/"
  }, {
    "id": "应用包不包含共享代码-application-packages-do-not-contain-shared-code",
    "content": "应用包不包含共享代码 /*application-packages-do-not-contain-shared-code*/"
  }, {
    "id": "后续步骤-next-steps",
    "content": "后续步骤 /*next-steps*/"
  }]
};
import __img0 from "./../../../public/images/docs/package-graph.png";
import {Callout} from '#components/callout';
import {Steps, Step} from '#components/steps';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Files, File, Folder} from '#components/files';
export const toc = [{
  depth: 3,
  url: "#创建一个空目录-create-an-empty-directory",
  title: _jsx(_Fragment, {
    children: "创建一个空目录 "
  })
}, {
  depth: 3,
  url: "#添加-packagejson-文件-add-a-packagejson",
  title: _jsx(_Fragment, {
    children: "添加 package.json 文件 "
  })
}, {
  depth: 3,
  url: "#添加-tsconfigjson-add-a-tsconfigjson",
  title: _jsxs(_Fragment, {
    children: ["添加 ", _jsx("code", {
      children: "tsconfig.json"
    }), " "]
  })
}, {
  depth: 3,
  url: "#添加包含源代码的-src-目录-add-a-src-directory-with-source-code",
  title: _jsxs(_Fragment, {
    children: ["添加包含源代码的 ", _jsx("code", {
      children: "src"
    }), " 目录 "]
  })
}, {
  depth: 3,
  url: "#将包添加到应用-add-the-package-to-an-application",
  title: _jsx(_Fragment, {
    children: "将包添加到应用 "
  })
}, {
  depth: 3,
  url: "#edit-turbojson-edit-turbojson",
  title: _jsxs(_Fragment, {
    children: ["Edit ", _jsx("code", {
      children: "turbo.json"
    }), " "]
  })
}, {
  depth: 3,
  url: "#运行-turbo-build-run-turbo-build",
  title: _jsxs(_Fragment, {
    children: ["运行 ", _jsx("code", {
      children: "turbo build"
    }), " "]
  })
}, {
  depth: 2,
  url: "#内部软件包的最佳实践-best-practices-for-internal-packages",
  title: _jsx(_Fragment, {
    children: "内部软件包的最佳实践 "
  })
}, {
  depth: 3,
  url: "#每个包一个-purpose-文件-one-purpose-per-package",
  title: _jsx(_Fragment, {
    children: "每个包一个 \"purpose\" 文件 "
  })
}, {
  depth: 3,
  url: "#应用包不包含共享代码-application-packages-do-not-contain-shared-code",
  title: _jsx(_Fragment, {
    children: "应用包不包含共享代码 "
  })
}, {
  depth: 2,
  url: "#后续步骤-next-steps",
  title: _jsx(_Fragment, {
    children: "后续步骤 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    img: "img",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "内部软件包"
      }), " 是你工作区的基石，为你提供了一种在代码库中共享代码和功能的强大方法。Turborepo 会使用 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中的依赖自动理解内部包之间的关系，并在后台创建 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "软件包图表"
      }), " 以优化代码库的工作流程。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "Internal Packages"
      }), " are the building blocks of your workspace, giving you a powerful way to share code and functionality across your repo. Turborepo automatically understands the relationships between Internal Packages using the dependencies in ", _jsx(_components.code, {
        children: "package.json"
      }), ", creating a ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), " under the hood to optimize your repository's workflows."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "Visual representation of a Package Graph in a Turborepo.",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsxs(_components.p, {
      children: ["让我们使用 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/structuring-a-repository#anatomy-of-a-package",
        children: "软件包结构"
      }), " 部分中的指导和 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#compiled-packages",
        children: "已编译的软件包"
      }), " 模式，创建你的第一个内部包，以便在你的代码库中共享数学实用程序。在以下步骤中，我们假设你已经拥有 ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation",
        children: ["使用以下方式创建新仓库 ", _jsx(_components.code, {
          children: "create-turbo"
        })]
      }), " 或正在使用类似结构的代码库。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Let's create your first Internal Package to share math utilities in your repo using the guidance in the ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/structuring-a-repository#anatomy-of-a-package",
        children: "Anatomy of a package"
      }), " section and the ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#compiled-packages",
        children: "Compiled Packages"
      }), " pattern. In the steps below, we assume you've ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation",
        children: ["created a new repository using ", _jsx(_components.code, {
          children: "create-turbo"
        })]
      }), " or are using a similarly structured repository."]
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "创建一个空目录-create-an-empty-directory",
          children: "创建一个空目录 "
        }), _jsx(_components.p, {
          children: "¥Create an empty directory"
        }), _jsxs(_components.p, {
          children: ["你需要一个用于放置包的目录。让我们在 ", _jsx(_components.code, {
            children: "./packages/math"
          }), " 上创建一个。"]
        }), _jsxs(_components.p, {
          children: ["¥You'll need a directory to put the package in. Let's create one at ", _jsx(_components.code, {
            children: "./packages/math"
          }), "."]
        }), _jsxs(Files, {
          children: [_jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "turbo.json"
          }), _jsx(Folder, {
            name: "apps"
          }), _jsxs(Folder, {
            name: "packages",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "math",
              green: true,
              defaultOpen: true
            }), _jsx(Folder, {
              name: "ui",
              children: _jsx(File, {
                name: "package.json"
              })
            }), _jsx(Folder, {
              name: "eslint-config",
              children: _jsx(File, {
                name: "package.json"
              })
            }), _jsx(Folder, {
              name: "typescript-config",
              children: _jsx(File, {
                name: "package.json"
              })
            })]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "添加-packagejson-文件-add-a-packagejson",
          children: "添加 package.json 文件 "
        }), _jsx(_components.p, {
          children: "¥Add a package.json"
        }), _jsxs(_components.p, {
          children: ["接下来，为包创建 ", _jsx(_components.code, {
            children: "package.json"
          }), "。添加此文件后，你将满足 ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/structuring-a-repository#specifying-packages-in-a-monorepo",
            children: "内部包的两个要求"
          }), " 的要求，使其可被 Turborepo 和你的工作区其他部分发现。"]
        }), _jsxs(_components.p, {
          children: ["¥Next, create the ", _jsx(_components.code, {
            children: "package.json"
          }), " for the package. By adding this file, you'll fulfill ", _jsx(_components.a, {
            href: "/docs/crafting-your-repository/structuring-a-repository#specifying-packages-in-a-monorepo",
            children: "the two requirements for an Internal Package"
          }), ", making it discoverable to Turborepo and the rest of your Workspace."]
        }), _jsxs(Callout, {
          type: "warn",
          children: [_jsxs(_components.p, {
            children: [_jsx(_components.code, {
              children: "package.json"
            }), " 中的 ", _jsx(_components.code, {
              children: "name"
            }), " 字段决定了你的包如何在你的工作区中导入。你在此处选择的名称（例如 ", _jsx(_components.code, {
              children: "@repo/math"
            }), "）将与其他包导入它的方式完全一致（例如 ", _jsx(_components.code, {
              children: "import {add} from '@repo/math/add'"
            }), "）。"]
          }), _jsxs(_components.p, {
            children: ["¥The ", _jsx(_components.code, {
              children: "name"
            }), " field in your ", _jsx(_components.code, {
              children: "package.json"
            }), " determines how your package can be\nimported throughout your workspace. The name you choose here (e.g.\n", _jsx(_components.code, {
              children: "@repo/math"
            }), ") is exactly how other packages will import it (e.g. ", _jsx(_components.code, {
              children: "import {add}         from '@repo/math/add'"
            }), ")."]
          })]
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/math/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"name\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"@repo/math\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"type\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"module\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"scripts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc --watch\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"exports\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"./add\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./src/add.ts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"default\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./dist/add.js\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"./subtract\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./src/subtract.ts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"default\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./dist/subtract.js\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"devDependencies\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"@repo/typescript-config\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"workspace:*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"typescript\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"latest\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/math/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"name\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"@repo/math\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"type\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"module\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"scripts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc --watch\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"exports\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"./add\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./src/add.ts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"default\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./dist/add.js\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"./subtract\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./src/subtract.ts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"default\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./dist/subtract.js\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"devDependencies\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"@repo/typescript-config\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"workspace:*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"typescript\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"latest\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/math/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"name\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"@repo/math\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"type\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"module\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"scripts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc --watch\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"exports\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"./add\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./src/add.ts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"default\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./dist/add.js\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"./subtract\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./src/subtract.ts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"default\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./dist/subtract.js\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"devDependencies\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"@repo/typescript-config\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"typescript\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"latest\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/math/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"name\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"@repo/math\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"type\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"module\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"scripts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"dev\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc --watch\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"build\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"tsc\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"exports\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"./add\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./src/add.ts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"default\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./dist/add.js\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"./subtract\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"types\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./src/subtract.ts\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "      \"default\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"./dist/subtract.js\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    }"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"devDependencies\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " {"
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"@repo/typescript-config\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"workspace:*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "    \"typescript\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: " \"latest\""
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          })]
        }), _jsxs(_components.p, {
          children: ["让我们逐一分解这个 ", _jsx(_components.code, {
            children: "package.json"
          }), "："]
        }), _jsxs(_components.p, {
          children: ["¥Let's break down this ", _jsx(_components.code, {
            children: "package.json"
          }), " piece-by-piece:"]
        }), _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "name"
              }), "：这是包发现的最关键字段。值 ", _jsx(_components.code, {
                children: "@repo/math"
              }), " 将成为工作区中所有导入语句使用的确切标识符。如果更改此名称，则必须相应地更新所有导入语句。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.strong, {
                children: _jsx(_components.code, {
                  children: "name"
                })
              }), ": This is the most critical field for package discoverability. The value ", _jsx(_components.code, {
                children: "@repo/math"
              }), " becomes the exact identifier used in import statements throughout your workspace. If you change this name, you must update all import statements accordingly."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "scripts"
              }), "：", _jsx(_components.code, {
                children: "dev"
              }), " 和 ", _jsx(_components.code, {
                children: "build"
              }), " 脚本使用 ", _jsx(_components.a, {
                href: "https://ts.nodejs.cn/docs/handbook/compiler-options.html",
                children: "TypeScript 编译器"
              }), " 编译软件包。", _jsx(_components.code, {
                children: "dev"
              }), " 脚本将监视源代码的更改并自动重新编译软件包。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.strong, {
                children: _jsx(_components.code, {
                  children: "scripts"
                })
              }), ": The ", _jsx(_components.code, {
                children: "dev"
              }), " and ", _jsx(_components.code, {
                children: "build"
              }), " script compile the package using ", _jsx(_components.a, {
                href: "https://ts.nodejs.cn/docs/handbook/compiler-options.html",
                children: "the TypeScript compiler"
              }), ". The ", _jsx(_components.code, {
                children: "dev"
              }), " script will watch for changes to source code and automatically recompile the package."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "devDependencies"
              }), "：", _jsx(_components.code, {
                children: "typescript"
              }), " 和 ", _jsx(_components.code, {
                children: "@repo/typescript-config"
              }), " 都是 ", _jsx(_components.code, {
                children: "devDependencies"
              }), "，因此你可以在 ", _jsx(_components.code, {
                children: "@repo/math"
              }), " 包中使用这些包。在实际软件包中，你可能会有更多 ", _jsx(_components.code, {
                children: "devDependencies"
              }), " 和 ", _jsx(_components.code, {
                children: "dependencies"
              }), "。 - 但我们现在可以保持简单。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.strong, {
                children: _jsx(_components.code, {
                  children: "devDependencies"
                })
              }), ": ", _jsx(_components.code, {
                children: "typescript"
              }), " and ", _jsx(_components.code, {
                children: "@repo/typescript-config"
              }), " are ", _jsx(_components.code, {
                children: "devDependencies"
              }), " so you can use those packages in the ", _jsx(_components.code, {
                children: "@repo/math"
              }), " package. In a real-world package, you will likely have more ", _jsx(_components.code, {
                children: "devDependencies"
              }), " and ", _jsx(_components.code, {
                children: "dependencies"
              }), " - but we can keep it simple for now."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "exports"
              }), "：为包定义多个入口点，以便可以在其他包（", _jsx(_components.code, {
                children: "import { add } from '@repo/math/add'"
              }), "）中使用。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsx(_components.strong, {
                children: _jsx(_components.code, {
                  children: "exports"
                })
              }), ": Defines multiple entrypoints for the package so it can be used in other packages (", _jsx(_components.code, {
                children: "import { add } from '@repo/math/add'"
              }), ")."]
            }), "\n"]
          }), "\n"]
        }), _jsxs(_components.p, {
          children: ["需要注意的是，此 ", _jsx(_components.code, {
            children: "package.json"
          }), " 将内部包 ", _jsx(_components.code, {
            children: "@repo/typescript-config"
          }), " 声明为依赖。Turborepo 会将 ", _jsx(_components.code, {
            children: "@repo/math"
          }), " 识别为 ", _jsx(_components.code, {
            children: "@repo/typescript-config"
          }), " 的依赖，以便对任务进行排序。"]
        }), _jsxs(_components.p, {
          children: ["¥Notably, this ", _jsx(_components.code, {
            children: "package.json"
          }), " declares an Internal Package, ", _jsx(_components.code, {
            children: "@repo/typescript-config"
          }), ", as a dependency. Turborepo will recognize ", _jsx(_components.code, {
            children: "@repo/math"
          }), " as a dependent of ", _jsx(_components.code, {
            children: "@repo/typescript-config"
          }), " for ordering your tasks."]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "添加-tsconfigjson-add-a-tsconfigjson",
          children: ["添加 ", _jsx(_components.code, {
            children: "tsconfig.json"
          }), " "]
        }), _jsxs(_components.p, {
          children: ["¥Add a ", _jsx(_components.code, {
            children: "tsconfig.json"
          })]
        }), _jsxs(_components.p, {
          children: ["通过将 ", _jsx(_components.code, {
            children: "tsconfig.json"
          }), " 文件添加到包的根目录来指定此包的 TypeScript 配置。TypeScript 具有 ", _jsxs(_components.a, {
            href: "https://ts.nodejs.cn/tsconfig#extends",
            children: [_jsx(_components.code, {
              children: "extends"
            }), " 键"]
          }), "，允许你在整个代码库中使用基本配置，并根据需要使用不同的选项进行覆盖。"]
        }), _jsxs(_components.p, {
          children: ["¥Specify the TypeScript configuration for this package by adding a ", _jsx(_components.code, {
            children: "tsconfig.json"
          }), " file to ", _jsx(_components.strong, {
            children: "the root of the package"
          }), ". TypeScript has ", _jsxs(_components.a, {
            href: "https://ts.nodejs.cn/tsconfig#extends",
            children: ["an ", _jsx(_components.code, {
              children: "extends"
            }), " key"]
          }), ", allowing you to use a base configuration throughout your repository and overwrite with different options as needed."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/math/tsconfig.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"extends\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"@repo/typescript-config/base.json\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"compilerOptions\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"outDir\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"dist\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"rootDir\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"src\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"include\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"src\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"exclude\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"node_modules\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"dist\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        }), _jsx(_components.p, {
          children: "你在这里完成了四件重要的事情："
        }), _jsx(_components.p, {
          children: "¥You've done four important things here:"
        }), _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "./packages/typescript-config"
              }), " 中的 ", _jsx(_components.code, {
                children: "@repo/typescript-config/base.json"
              }), " 配置包含你需要的所有配置，因此你可以从中扩展。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥The ", _jsx(_components.code, {
                children: "@repo/typescript-config/base.json"
              }), " configuration that lives in ", _jsx(_components.code, {
                children: "./packages/typescript-config"
              }), " has all the configuration you need so you extend from it."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.code, {
                children: "compilerOptions"
              }), " 中的 ", _jsxs(_components.a, {
                href: "https://ts.nodejs.cn/tsconfig/#outDir",
                children: [_jsx(_components.code, {
                  children: "outDir"
                }), " 键"]
              }), " 会告诉 TypeScript 将编译输出放在哪里。它与 ", _jsx(_components.code, {
                children: "package.json"
              }), " 中 ", _jsx(_components.code, {
                children: "exports"
              }), " 指定的目录匹配。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsxs(_components.a, {
                href: "https://ts.nodejs.cn/tsconfig/#outDir",
                children: ["The ", _jsx(_components.code, {
                  children: "outDir"
                }), " key"]
              }), " in ", _jsx(_components.code, {
                children: "compilerOptions"
              }), " tells TypeScript where to put the compiled output. It matches the directory specified in your ", _jsx(_components.code, {
                children: "exports"
              }), " in ", _jsx(_components.code, {
                children: "package.json"
              }), "."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsxs(_components.a, {
                href: "https://ts.nodejs.cn/tsconfig/#rootDir",
                children: [_jsx(_components.code, {
                  children: "compilerOptions"
                }), " 中的 ", _jsx(_components.code, {
                  children: "rootDir"
                }), " 键"]
              }), " 确保 ", _jsx(_components.code, {
                children: "outDir"
              }), " 中的输出使用与 ", _jsx(_components.code, {
                children: "src"
              }), " 目录相同的结构。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥", _jsxs(_components.a, {
                href: "https://ts.nodejs.cn/tsconfig/#rootDir",
                children: ["The ", _jsx(_components.code, {
                  children: "rootDir"
                }), " key in ", _jsx(_components.code, {
                  children: "compilerOptions"
                })]
              }), " ensures that the output in ", _jsx(_components.code, {
                children: "outDir"
              }), " uses the same structure as the ", _jsx(_components.code, {
                children: "src"
              }), " directory."]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["\n", _jsxs(_components.p, {
              children: [_jsx(_components.a, {
                href: "https://ts.nodejs.cn/tsconfig/#include",
                children: _jsx(_components.code, {
                  children: "include"
                })
              }), " 和 ", _jsx(_components.a, {
                href: "https://ts.nodejs.cn/tsconfig/#exclude",
                children: _jsx(_components.code, {
                  children: "exclude"
                })
              }), " 键并非从基本配置 ", _jsx(_components.a, {
                href: "https://ts.nodejs.cn/tsconfig#include",
                children: "根据 TypeScript 规范"
              }), " 继承，因此你在此处添加了它们。"]
            }), "\n", _jsxs(_components.p, {
              children: ["¥The ", _jsx(_components.a, {
                href: "https://ts.nodejs.cn/tsconfig/#include",
                children: _jsx(_components.code, {
                  children: "include"
                })
              }), " and ", _jsx(_components.a, {
                href: "https://ts.nodejs.cn/tsconfig/#exclude",
                children: _jsx(_components.code, {
                  children: "exclude"
                })
              }), " keys are not inherited from the base configuration, ", _jsx(_components.a, {
                href: "https://ts.nodejs.cn/tsconfig#include",
                children: "according to the TypeScript specification"
              }), ", so you've included them here."]
            }), "\n"]
          }), "\n"]
        }), _jsxs(Callout, {
          type: "info",
          children: [_jsxs(_components.p, {
            children: ["关于 TypeScript 配置还有很多需要学习，但目前这是一个很好的起点。如果你想了解更多信息，请访问 ", _jsx(_components.a, {
              href: "https://ts.nodejs.cn/tsconfig",
              children: "TypeScript 官方文档"
            }), " 或 ", _jsx(_components.a, {
              href: "/docs/guides/tools/typescript",
              children: "我们的 TypeScript 指南"
            }), "。"]
          }), _jsxs(_components.p, {
            children: ["¥There's a lot more to learn about TypeScript configuration, but this is a good\nplace to start for now. If you'd like to learn more, visit ", _jsx(_components.a, {
              href: "https://ts.nodejs.cn/tsconfig",
              children: "the official\nTypeScript documentation"
            }), " or ", _jsx(_components.a, {
              href: "/docs/guides/tools/typescript",
              children: "our\nTypeScript guide"
            }), "."]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "添加包含源代码的-src-目录-add-a-src-directory-with-source-code",
          children: ["添加包含源代码的 ", _jsx(_components.code, {
            children: "src"
          }), " 目录 "]
        }), _jsxs(_components.p, {
          children: ["¥Add a ", _jsx(_components.code, {
            children: "src"
          }), " directory with source code"]
        }), _jsxs(_components.p, {
          children: ["你现在可以为你的包编写一些代码。在 ", _jsx(_components.code, {
            children: "src"
          }), " 目录中创建两个文件："]
        }), _jsxs(_components.p, {
          children: ["¥You can now write some code for your package. Create two files inside a ", _jsx(_components.code, {
            children: "src"
          }), " directory:"]
        }), _jsxs(Tabs, {
          items: ['add.ts', 'subtract.ts'],
          children: [_jsx(Tab, {
            value: "add.ts",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/math/src/add.ts",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "export"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: " const"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: " add"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: " ="
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " (a"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " number"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " b"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " number"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: ") "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "=>"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " a "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "+"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " b;"
                    })]
                  })
                })
              })
            })
          }), _jsx(Tab, {
            value: "subtract.ts",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./packages/math/src/subtract.ts",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
                children: _jsx(_components.code, {
                  children: _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "export"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: " const"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-function)",
                        "--shiki-dark": "var(--shiki-token-function)"
                      },
                      children: " subtract"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: " ="
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " (a"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " number"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " b"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-constant)",
                        "--shiki-dark": "var(--shiki-token-constant)"
                      },
                      children: " number"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: ") "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "=>"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " a "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "-"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " b;"
                    })]
                  })
                })
              })
            })
          })]
        }), _jsxs(_components.p, {
          children: ["这些文件映射到你稍后运行 ", _jsx(_components.code, {
            children: "turbo build"
          }), " 时 ", _jsx(_components.code, {
            children: "tsc"
          }), " 将创建的输出。"]
        }), _jsxs(_components.p, {
          children: ["¥These files map to the outputs that will be created by ", _jsx(_components.code, {
            children: "tsc"
          }), " when you run ", _jsx(_components.code, {
            children: "turbo build"
          }), " in a moment."]
        })]
      }), _jsxs(Step, {
        children: [_jsx(_components.h3, {
          id: "将包添加到应用-add-the-package-to-an-application",
          children: "将包添加到应用 "
        }), _jsx(_components.p, {
          children: "¥Add the package to an application"
        }), _jsxs(_components.p, {
          children: ["你已准备好在应用中使用新的包。让我们将它添加到 ", _jsx(_components.code, {
            children: "web"
          }), " 应用中。"]
        }), _jsxs(_components.p, {
          children: ["¥You're ready to use your new package in an application. Let's add it to the ", _jsx(_components.code, {
            children: "web"
          }), " application."]
        }), _jsxs(Tabs, {
          groupId: "package-manager",
          items: ['pnpm', 'yarn', 'npm', 'bun'],
          persist: true,
          children: [_jsx(Tab, {
            value: "pnpm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "apps/web/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  \"dependencies\": {"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+   \"@repo/math\": \"workspace:*\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"next\": \"latest\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"react\": \"latest\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"react-dom\": \"latest\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  },"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "yarn",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "apps/web/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  \"dependencies\": {"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+   \"@repo/math\": \"*\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"next\": \"latest\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"react\": \"latest\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"react-dom\": \"latest\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  },"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "npm",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "apps/web/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  \"dependencies\": {"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+   \"@repo/math\": \"*\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"next\": \"latest\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"react\": \"latest\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"react-dom\": \"latest\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  },"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "bun",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "apps/web/package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  \"dependencies\": {"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+   \"@repo/math\": \"workspace:*\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"next\": \"latest\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"react\": \"latest\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "    \"react-dom\": \"latest\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  },"
                    })
                  })]
                })
              })
            })
          })]
        }), _jsxs(Callout, {
          type: "warn",
          children: [_jsx(_components.p, {
            children: "你只需更改代码库中的依赖即可。确保运行包管理器的安装命令来更新锁文件。"
          }), _jsx(_components.p, {
            children: "¥You just changed the dependencies in your repo. Make sure to run your package\nmanager's installation command to update your lockfile."
          })]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "@repo/math"
          }), " 现在可在 ", _jsx(_components.code, {
            children: "web"
          }), " 应用中使用，你可以在代码中使用它："]
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "@repo/math"
          }), " is now available in the ", _jsx(_components.code, {
            children: "web"
          }), " application, you can use it in your code:"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "apps/web/src/app/page.tsx",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " { add } "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " '@repo/math/add'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ";"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "function"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " Page"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "() {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  return"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " <"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "div"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ">{"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "("
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: "1"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " 2"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ")}</"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "div"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ">;"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " default"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " Page;"
                })]
              })]
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "edit-turbojson-edit-turbojson",
          children: ["Edit ", _jsx(_components.code, {
            children: "turbo.json"
          }), " "]
        }), _jsxs(_components.p, {
          children: ["将新 ", _jsx(_components.code, {
            children: "@repo/math"
          }), " 库的工件添加到 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中 ", _jsx(_components.code, {
            children: "build"
          }), " 任务的 ", _jsx(_components.code, {
            children: "outputs"
          }), " 中。这确保了 Turborepo 会缓存其构建输出，因此当你开始运行构建时，它们可以立即恢复。"]
        }), _jsxs(_components.p, {
          children: ["¥Add the artifacts for the new ", _jsx(_components.code, {
            children: "@repo/math"
          }), " library to the ", _jsx(_components.code, {
            children: "outputs"
          }), " for the ", _jsx(_components.code, {
            children: "build"
          }), " task in ", _jsx(_components.code, {
            children: "turbo.json"
          }), ". This ensures that its build outputs will be cached by Turborepo, so they can be restored instantly when you start running builds."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"dependsOn\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"^build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"outputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\".next/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"!.next/cache/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  className: "highlighted-word",
                  children: "\"dist/**\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h3, {
          id: "运行-turbo-build-run-turbo-build",
          children: ["运行 ", _jsx(_components.code, {
            children: "turbo build"
          }), " "]
        }), _jsxs(_components.p, {
          children: ["¥Run ", _jsx(_components.code, {
            children: "turbo build"
          })]
        }), _jsxs(_components.p, {
          children: ["如果你已经安装了 ", _jsxs(_components.a, {
            href: "/docs/getting-started/installation#global-installation",
            children: ["全局安装 ", _jsx(_components.code, {
              children: "turbo"
            })]
          }), "，请在工作区根目录的终端中运行 ", _jsx(_components.code, {
            children: "turbo build"
          }), "。你还可以使用包管理器从 ", _jsx(_components.code, {
            children: "package.json"
          }), " 运行 ", _jsx(_components.code, {
            children: "build"
          }), " 脚本，这将使用 ", _jsx(_components.code, {
            children: "turbo run build"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥If you've ", _jsxs(_components.a, {
            href: "/docs/getting-started/installation#global-installation",
            children: ["installed ", _jsx(_components.code, {
              children: "turbo"
            }), " globally"]
          }), ", run ", _jsx(_components.code, {
            children: "turbo build"
          }), " in your terminal at the root of your Workspace. You can also run the ", _jsx(_components.code, {
            children: "build"
          }), " script from ", _jsx(_components.code, {
            children: "package.json"
          }), " with your package manager, which will use ", _jsx(_components.code, {
            children: "turbo run build"
          }), "."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "@repo/math"
          }), " 包在 ", _jsx(_components.code, {
            children: "web"
          }), " 应用之前构建，以便 ", _jsx(_components.code, {
            children: "./packages/math/dist"
          }), " 中的运行时代码在 ", _jsx(_components.code, {
            children: "web"
          }), " 应用打包时可供使用。"]
        }), _jsxs(_components.p, {
          children: ["¥The ", _jsx(_components.code, {
            children: "@repo/math"
          }), " package built before the ", _jsx(_components.code, {
            children: "web"
          }), " application built so that the runtime code in ", _jsx(_components.code, {
            children: "./packages/math/dist"
          }), " is available to the ", _jsx(_components.code, {
            children: "web"
          }), " application when it bundles."]
        }), _jsxs(Callout, {
          type: "info",
          children: [_jsxs(_components.p, {
            children: ["你可以再次运行 ", _jsx(_components.code, {
              children: "turbo build"
            }), "，以毫秒为单位查看你的 ", _jsx(_components.code, {
              children: "web"
            }), " 应用的重建情况。我们将在 ", _jsx(_components.a, {
              href: "/docs/crafting-your-repository/caching",
              children: "缓存指南"
            }), " 中详细讨论这一点。"]
          }), _jsxs(_components.p, {
            children: ["¥You can run ", _jsx(_components.code, {
              children: "turbo build"
            }), " again to see your ", _jsx(_components.code, {
              children: "web"
            }), " application rebuild in\n", _jsx(_components.strong, {
              children: "milliseconds"
            }), ". We'll discuss this at length in ", _jsx(_components.a, {
              href: "/docs/crafting-your-repository/caching",
              children: "the Caching\nguide"
            }), "."]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "内部软件包的最佳实践-best-practices-for-internal-packages",
      children: "内部软件包的最佳实践 "
    }), "\n", _jsx(_components.p, {
      children: "¥Best practices for Internal Packages"
    }), "\n", _jsx(_components.h3, {
      id: "每个包一个-purpose-文件-one-purpose-per-package",
      children: "每个包一个 \"purpose\" 文件 "
    }), "\n", _jsx(_components.p, {
      children: "¥One \"purpose\" per package"
    }), "\n", _jsx(_components.p, {
      children: "创建内部包时，建议创建包含单个 \"purpose\" 的包。这并非严格的科学或规则，而是一项最佳实践，取决于你的仓库、规模、组织、团队需求等等。此策略有几个优点："
    }), "\n", _jsx(_components.p, {
      children: "¥When you're creating Internal Packages, it's recommended to create packages that have a single \"purpose\". This isn't a strict science or rule, but a best practice depending on your repository, your scale, your organization, what your teams need, and more. This strategy has several advantages:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "更易于理解：随着仓库规模的扩大，在仓库中工作的开发者将更容易找到他们需要的代码。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Easier to understand"
          }), ": As a repository scales, developers working in the repository will more easily be able to find the code they need."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["减少每个包的依赖：每个包使用更少的依赖，使 Turborepo 能够更有效地使用 ", _jsx(_components.a, {
            href: "/docs/reference/prune",
            children: "修剪软件包图的依赖"
          }), "。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Reducing dependencies per package"
          }), ": Using fewer dependencies per package makes it so Turborepo can more effectively ", _jsx(_components.a, {
            href: "/docs/reference/prune",
            children: "prune the dependencies of your package graph"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "一些示例如下："
    }), "\n", _jsx(_components.p, {
      children: "¥Some examples include:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "@repo/ui"
          }), "：包含所有共享 UI 组件的包"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: _jsx(_components.code, {
              children: "@repo/ui"
            })
          }), ": A package containing all of your shared UI components"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "@repo/tool-specific-config"
          }), "：用于管理特定工具配置的包"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: _jsx(_components.code, {
              children: "@repo/tool-specific-config"
            })
          }), ": A package for managing configuration of a specific tool"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "@repo/graphs"
          }), "：用于创建和操作图形数据的字段特定库"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: _jsx(_components.code, {
              children: "@repo/graphs"
            })
          }), ": A domain-specific library for creating and manipulating graphical data"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "应用包不包含共享代码-application-packages-do-not-contain-shared-code",
      children: "应用包不包含共享代码 "
    }), "\n", _jsx(_components.p, {
      children: "¥Application Packages do not contain shared code"
    }), "\n", _jsxs(_components.p, {
      children: ["创建 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-types#application-packages",
        children: "应用包"
      }), " 时，最好避免在这些包中放置共享代码。相反，你应该为共享代码创建一个单独的包，并让应用包依赖于该包。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When you're creating ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-types#application-packages",
        children: "Application Packages"
      }), ", it's best to avoid putting shared code in those packages. Instead, you should create a separate package for the shared code and have the application packages depend on that package."]
    }), "\n", _jsxs(_components.p, {
      children: ["此外，应用包不应安装到其他包中。相反，它们应该被视为 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "软件包图表"
      }), " 的入口点。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Additionally, Application Packages are not meant to be installed into other packages. Instead, they should be thought of as an entrypoint to your ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), "."]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: ["此规则包含 ", _jsx(_components.a, {
          href: "/docs/core-concepts/package-types#installing-an-applicaiton-package-into-another-package",
          children: "罕见例外"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥There are ", _jsx(_components.a, {
          href: "/docs/core-concepts/package-types#installing-an-applicaiton-package-into-another-package",
          children: "rare\nexceptions"
        }), "\nto this rule."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "后续步骤-next-steps",
      children: "后续步骤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Next steps"
    }), "\n", _jsxs(_components.p, {
      children: ["新的内部软件包到位后，你可以启动 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks",
        children: "配置任务"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥With a new Internal Package in place, you can start ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks",
        children: "configuring tasks"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
